<template>
  <section class="signup">
    <div class="headering">
      <h1>{{ $t('front_page.signup_form') }}</h1>
      <span v-if="isSignup" class="required"> = {{
        $t('front_page.required')
      }}</span>
      <span v-else>{{ $t('front_page.confirm') }}</span>
    </div>
    <!-- <p v-if="lang == 'ja'" class="notice">
            現在、新規登録の受付を一時停止しております。<br>
            誠に申し訳ございませんが、再開まで今しばらくお待ちいただけますようお願い申し上げます。
        </p>
        <p v-else class="notice">
            We are currently pausing new registrations.<br>
            We apologize for the inconvenience and appreciate your patience as
            we work to reopen soon.
        </p> -->
    <form v-if="isSignup" class="signup_form" @submit.prevent="validation">
      <label for="name"><span class="required">{{ $t('name')
      }}</span><input type="text" id="name" name="name"
          v-model="signup_data.name"
          :placeholder="$t('front_page.sample_username')" maxlength="20"
          tabindex>
        <p v-if="error.name" class="error_msg" v-html='error.name'></p>
      </label>
      <label for="email"><span class="required">{{ $t('email')
      }}</span><input type="email" id="email" name="email"
          v-model="signup_data.email" placeholder="name@email.com"
          maxLength="100" size="34" tabindex>
        <p v-if="error.email" class="error_msg error_email"
          v-html='error.email'></p>
      </label>
      <label for="email_confirm"><span class="required">{{
        $t('front_page.re_enter_email') }}</span>
        <input type="email" id="email_confirm" name="email_confirm"
          v-model="signup_data.email_confirm" placeholder="name@email.com"
          maxlength="100" size="34" tabindex>
        <p v-if="error.email_confirm" class="error_msg">
          {{ error.email_confirm }}
        </p>
      </label>
      <div class="flex-row prefer_lang"><span class="required">
          {{ $t('front_page.prefer_lang') }}</span>
        <div class="flex-row label__block">
          <label for="lang_en">
            <input type="radio" id="lang_en" name="preferred_lang" value="en"
              v-model="signup_data.preferred_lang" tabindex>English
          </label>
          <label for="lang_ja">
            <input type="radio" id="lang_ja" name="preferred_lang" value="jp"
              v-model="signup_data.preferred_lang" tabindex>日本語
          </label>
        </div>
      </div>
      <label class="siteurl">
        <p v-html="$t('front_page.site_url')"></p><input type="text"
          id="siteurl" name="siteurl" placeholder="http://www.yoursite.url"
          maxlength="100" size="34" tabindex v-model="hidden_data.siteurl">

        <p v-if="error.siteurl" class="error_msg">{{ error.siteurl }}
        </p>
      </label>
      <label class="flex-row agreement" for="agreement"><span class="required">
          <a href="/legal/terms" target="_blank">{{
            $t('front_page.agreement') }}</a></span>
        <input type="checkbox" id="agreement" name="agreement" value="on"
          v-model="signup_data.agreement" tabindex>
      </label>
      <p v-if="error.agreement" class="error_msg">{{ $t('error.agreement')
      }}
      </p>
      <div class="bts">
        <button class="bt active" type="submit">
          {{ $t('front_page.next') }}</button>
      </div>
    </form>
    <div v-else>
      <form id="signup_cap" class="confirm_form" name="signup" ref="signupForm"
        :action="`${url}/cgi-bin/signup.cgi`" method="post">
        <input type="hidden" name="lang"
          :id="signup_data.preferred_lang === 'en' ? 'en' : ''"
          :value="signup_data.preferred_lang">
        <input type="hidden" v-for="(value, i) in send_data" :key="i"
          :name="i" :value="value">
        <div>
          <dl class="confirm_form__item">
            <dt>{{ $t('name') }}</dt>
            <dd>{{ send_data.name }}</dd>
          </dl>
          <dl class="confirm_form__item">
            <dt>{{ $t('email') }}</dt>
            <dd>{{ send_data.email }}</dd>
          </dl>
          <dl class="confirm_form__item">
            <dt>{{ $t('front_page.prefer_lang') }}</dt>
            <dd>{{ send_data.preferred_lang == 'jp' ? '日本語' :
              'English' }}
            </dd>
          </dl>
          <dl class="confirm_form__item">
            <dt>{{ $t('accounts.your_site') }}</dt>
            <dd>{{ send_data.siteurl }}</dd>
          </dl>
          <p><a href="/legal/terms" target="_blank">{{
            $t('front_page.agreement') }}</a><input type="checkbox" checked
              disabled>
          </p>
        </div>
        <div class="bts">
          <div class="bt active" @click="isSignup = !isSignup">
            {{ $t('bts.back') }}</div>
          <button class="bt join g-recaptcha" type="submit" data-action="submit"
            data-sitekey="6LeteQEVAAAAAL4q1UlphHxI5DgXg4kLZT6AfUCe"
            data-callback="onSubmit">
            {{ $t('front_page.signup') }}</button>
        </div>
        <ul class="notice">
          <li>{{ $t('front_page.notice.msg1') }}</li>
          <li>{{ $t('front_page.notice.msg2') }}</li>
        </ul>
      </form>
    </div>
  </section>
</template>

<script>
import { textValidation } from "@/shared"
export default {
  name: 'Signup',
  data() {
    return {
      url: window.location.hostname === 'stg.dticash.com' ? process.env.VUE_APP_OLDURL2 : process.env.VUE_APP_OLDURL,
      isSignup: true,
      isEmail: true,
      signup_data: {
        name: "",
        email: "",
        email_confirm: "",
        preferred_lang: localStorage.selectLang,
        agreement: ""
      },
      hidden_data: {
        action: "signup",
        pinktok: "0",
        owner_id: "0",
        siteurl: ""
      },
      send_data: {},
      error: {
        agreement: false,
        name: false,
        email: "",
        email_confirm: "",
        siteurl: ""
      },
      error_confirm: false,
      error_counts: 0
    }
  },
  mixins: [textValidation],
  mounted() {
    console.log('Initial localStorage.selectLang:', localStorage.selectLang);
    if (localStorage.selectLang === 'ja' || localStorage.selectLang === 'jp') {
      this.signup_data.preferred_lang = 'jp';
    } else if (localStorage.selectLang === 'en') {
      this.signup_data.preferred_lang = 'en';
    } else {
      // ブラウザの言語設定を使用
      const browserLang = navigator.language.split('-')[0];
      this.signup_data.preferred_lang = browserLang === 'ja' ? 'jp' : 'en';
    }
  },
  computed: {
    lang() {
      return this.$store.state.locales.locale;
    }
  },
  watch: {
    "lang": {
      handler(e) {
        this.signup_data.preferred_lang = e == 'ja' ? 'jp' : e
      }
    },
    "signup_data.preferred_lang": {
      handler(e) {
        let v = e == 'jp' ? 'ja' : e
        localStorage.selectLang = document.body.className = v;
        console.log('signup')
        this.$store.dispatch("locales/getLocaleActions", v);
      }
    }
  },
  methods: {
    checkEmailFormat(str) {
      console.log("mail check")
      let error = '';
      if (this.checkEmail(str) === false) {
        error = '';
      } else {
        error = this.$t('error.email_invalid')
      }
      this.error.email = error
      this.isEmail = error != '' ? true : false
    },
    checkEmail2(str) {
      this.error.email_confirm = str === this.signup_data.email ? '' : this.$t('error.email_confirm');
    },
    validation() {
      let data = this.signup_data
      data.siteurl = this.hidden_data.siteurl;
      console.log(data)
      let error_count = 0
      for (let i in data) {
        console.log('i', i)
        let item = data[i]
        if (i != 'preferred_lang') {
          if (i != 'siteurl' && item == '') {
            console.log(i)
            if (i == 'agreement') {
              this.error[i] = this.$t('error.agreement')
            } else {
              this.error[i] = this.$t('error.input')
            }
          } else {
            switch (i) {
              case 'name':
                this.error[i] = this.checkName(item) ? this.$t("error.only_use", ["A-z 0-9  _ - . () "]) : '';
                break
              case 'email':
                this.checkEmailFormat(item);
                break
              case 'email_confirm':
                this.checkEmail2(item);
                break
              case 'siteurl':
                if (item == '') {
                  this.error[i] = ''
                } else {
                  let check = this.error.siteurl = this.checkSiteurl(item);
                  this.error[i] = check ? this.$t('error.url') : '';
                };
                break
              default:
                this.error[i] = ''
            }
          }
        }
      }
      for (let key in this.error) {
        if (this.error[key] !== '') {
          error_count++;
        }
      }

      console.log(error_count)
      if (error_count == 0) {
        this.goNext();
      }
    },
    goNext() {
      this.isSignup = false
      this.send_data = { ...this.signup_data, ...this.hidden_data };
      this.send_data.agreement = this.send_data.agreement ? 'on' : ''
    },
    onSubmit(token) {
      this.$refs.signupForm.submit();
    },
    onReCapchaError() {
      alert("recaptcha error");
    }
  }
}
</script>
<style scoped>
@import '@/assets/front/form.css';

.notice {
  margin: 3em auto;
}

.form-disabled {
  opacity: 0.2;
}
</style>